import React from "react";
import PropTypes from "prop-types";
import { scaleTime } from "d3-scale";

import style from "./style.module.scss";

export function Timer(props) {
  const time = scaleTime()
    .domain([new Date(props.value), new Date(0, 0, 0, 0, 0, 0)])
    .range([props.min, props.max]);

  const val = time.invert(props.currentFrame);
  return <span className={style.timerText}>{getFormattedTime(val)}</span>;
}

Timer.propTypes = {
  /**
   * starting time to set animation timer count down
   */
  value: PropTypes.instanceOf(Date),
  /**
   * lower limit of frame for the animation provided
   */
  min: PropTypes.number,
  /**
   * upper limit of frame for the animation provided
   */
  max: PropTypes.number,
};

Timer.defaultProps = {
  value: new Date(0, 0, 0),
};

const getFormattedTime = (time) => {
  const hours = formatValue(time.getHours());
  const minutes = formatValue(time.getMinutes());
  const seconds = formatValue(time.getSeconds());
  return `${hours} : ${minutes} : ${seconds}`;
};

const formatValue = (value) => {
  if (value < 10) return `0${value}`;
  else return `${value}`;
};
